import { makeTAddTypeFilterLogic } from '../../TYPE/logic';
import { TAddType } from '../../../../../types';
export var showLogic = makeTAddTypeFilterLogic({
    is: TAddType.MANDATARY,
});
